export const fromServer = items => {
    const parsed = {};
    const collection = items || [];

    collection.forEach(v => {
        if (v) {
            parsed[v.unique_id] = v;
        }
    });

    return parsed;
}
